import { Container_Insights_Temperatures } from '@/graphql/types';

import { store } from './store';

export type TemperaturesFilter = Container_Insights_Temperatures & {
  selected: boolean;
};

export const ControlledAtmosphereTemperaturesFilter: TemperaturesFilter = {
  id: 'controlled-atmosphere',
  label: 'Controlled atmosphere',
  selected: false,
  created_at: 0,
  updated_at: 0,
};

const setTemperatures = (temperatures: Container_Insights_Temperatures[]) => {
  store.temperatures = temperatures.map((temperature) => ({
    ...temperature,
    selected: false,
  }));
};

const getTemperature = (id: string): TemperaturesFilter | null => {
  const temperature = store.temperatures.find(
    (temperature) => temperature.id === id,
  );
  return temperature || null;
};

const setSelectedTemperatures = (ids: string[]) => {
  store.temperatures.forEach((temperature) => {
    temperature.selected = ids.includes(temperature.id);
  });
};

const unselectTemperature = (id: string) => {
  const temperature = store.temperatures.find(
    (temperature) => temperature.id === id,
  );
  if (temperature) {
    temperature.selected = false;
  }
};

const selectAllTemperatures = () => {
  store.temperatures.forEach((temperature) => {
    temperature.selected = true;
  });
};

const unselectAllTemperatures = () => {
  store.temperatures.forEach((temperature) => {
    temperature.selected = false;
  });
};

export {
  setTemperatures,
  setSelectedTemperatures,
  getTemperature,
  unselectTemperature,
  selectAllTemperatures,
  unselectAllTemperatures,
};
